export { default } from "./SignupSuccessPage";
